import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Vial from './Vial.js';

export default class Vials extends AContainer
{
    constructor(scene, colors)
    {
        super(scene);

        this.topVials = [];
        this.bottomVials = [];
        this.vials = [];
        this.zones = [];
        this.colors = colors;

        this.createVials();
        this.tweenInVials();
    }

    createVials()
    {
        for (let i=0; i<4; i++)
        {
            let vial = new Vial(this.scene, 195 + (i*210), -200, i, this.colors[i], this);
            this.vials.push(vial);
        }

        if(gameData.customFuzzbug) 
        {
            let rand = Phaser.Math.Between(0, this.vials.length-1)
            this.randVial = this.vials[rand];
            gameData.customReplacementID = rand;

            //console.log(this.randVial, gameData.customReplacementID);
            this.randVial.setCustom();
        }
    }

    getCustomVial()
    {
        this.vials.forEach((vial)=>{if(vial.isCustom) return vial;});
    }

    removeCounter()
    {
        this.vials.forEach((vial)=>{vial.hasCounter = false;});
    }

    toggleVials(TorF)
    {
        this.vials.forEach((vial)=>{vial.toggleVial(TorF);});
    }

    enableDrag()
    {
        this.vials.forEach((vial)=>{vial.enableDrag();});
    }

    disableAllBugs()
    {
        // for(let i=0; i<gameData.vialBugs.length; i++){
        //     gameData.vialBugs[i].forEach((bug)=>{
        //         bug.disabled();
        //     });
        // }

        this.scene.dragBugs.forEach((bugs)=>{bugs.disabled();});
    }

    removeCounters()
    {
        this.vials.forEach((vial)=>{vial.removeCounter();});
    }

    setMinMax()
    {
        this.amounts = [];
        this.vials.forEach((vial)=>{this.amounts.push(vial.counter);});

        this.min = Math.min(...this.amounts);
        this.max = Math.max(...this.amounts);
        //console.log(this.min, this.max);
    }

    getMinMax(minMax)
    {
        if(minMax === "max") return this.max;
        else if(minMax === "min") return this.min;
    }

    tweenInVials()
    {
        this.vials.forEach((vial)=>{
            vial.vials.forEach((innerVial)=>{
                this.scene.addTween(innerVial, 1000, {y:vial.startY, delay:100*vial.ind}, Phaser.Math.Easing.Quadratic.Out,
                    ()=>{if(vial.ind === 0) this.scene.playSound("jars_landing");});
            });
        });
    }

    tweenOutVials()
    {
        this.vials.forEach((vial)=>{
            vial.vials.forEach((innerVial)=>{
                this.scene.addTween(innerVial, 1000, {x:"-=" + this.scene.scale.width}, Phaser.Math.Easing.Quadratic.In);
            });
        });
    }

    cleanUp()
    {
        //console.log("cleaning UP");
       this.bottomVials.forEach((vial)=>{vial.destroy();});
       this.topVials.forEach((vial)=>{vial.destroy();});
       //this.vials.forEach((vial)=>{vial.destroy();});

       this.bottomVials = [];
       this.topVials = [];
       this.vials = [];
    }
}